/**
 * Internal dependencies.
 */
import {restBase} from "../../endpoints";

export const settingsEndpoint = `${restBase}settings`;
